var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('toolbar'),_c('transition',{attrs:{"enter-active-class":" delay animate__animated animate__slideInDown","appear":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }